module.exports = __webpack_public_path__ + "img/100.b735a221.jpg";